define([
  "marionette",
  "backbone",
  "highcharts/highcharts",
  "jquery",
  "messaging/messenger",
  "moment-timezone",
], function (Marionette, Backbone, Highcharts, $, Messenger, Moment) {
  "use strict";

  // Need a Unicode emoji character to ensure valid splitting (since it
  // should never be part of a valid name or ID). Using the penguin emoji.
  const AGENT_PARAM_DELIMITER = "\u{1F427}";

  const ReportUtils = {
    AGENT_PARAM_DELIMITER: AGENT_PARAM_DELIMITER,
    parseAgentParam: function (agentsParam) {
      if (!agentsParam) {
        return [];
      }
      return agentsParam.split(AGENT_PARAM_DELIMITER).filter(function (name) {
        return name.length > 0;
      });
    },
    joinAgentParam: function (agentNames) {
      if (!agentNames || agentNames.length === 0) {
        return "";
      }
      return agentNames.join(AGENT_PARAM_DELIMITER) + AGENT_PARAM_DELIMITER;
    },
    encodeTimezone: function (val) {
      if (val) {
        return val.replace(/\//g, "~");
      }
      return val;
    },
    figureOutText: function (text, isUserFriendly, offset, batchSize) {
      let suffix = "";
      if (isUserFriendly) {
        suffix = "Display";
      }
      // The below regex should match {, followed by one or more characters, followed by }
      // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions for reference,
      // among other sites.
      // The question mark makes the + non-greedy, so that instead of matching the last possible } after a {,
      // it matches the first possible } after a { (which is what we want).
      // dot means any character;
      // plus means 1 or more times
      const regex = /{.+?}/g;
      return text.replace(regex, function (match) {
        //get the parameter we'll be putting in
        let strParam;
        try {
          strParam = Messenger.reqres.request("param" + suffix + ":" + match);
        } catch (e) {
          console.error("Failed to get report parameter param" + suffix + ":" + match, e);
          strParam = "";
        }
        if (match === "{bucket}" && strParam <= 1) {
          strParam = strParam * 10;
        }
        if (match === "{offset}" && offset) {
          strParam = offset;
        }
        if (match === "{batchSize}" && batchSize) {
          strParam = batchSize;
        }
        //If the parameter is null, don't put the string null in the url, instead leave it empty so that the missing
        // param can be caught later
        if (strParam === null || strParam === undefined) {
          strParam = "";
        } else if (!isUserFriendly) {
          if (match === "{timeZone}") {
            strParam = ReportUtils.encodeTimezone(strParam);
          } else {
            strParam = encodeURIComponent("" + strParam);
          }
        }
        return strParam;
      });
    },
    fetchReportParameters: function (text) {
      //Updated version of _figureOutPOSTInputs. Since table exports are now done on the client side, there is no need
      //to wrap them in <input> tags. So instead, this just returns a simple JSON object
      const retVal = {};
      const regex = /{.+?}/g;
      const paramArray = text.match(regex);
      if (paramArray && paramArray.length) {
        //then fetch the parameters
        let idx = 0;
        for (let i = 0; i < paramArray.length; i++) {
          // Get the parameter we'll be putting in

          // Remove wrapping curly braces -- {parameter} becomes parameter
          const parameter = paramArray[i].slice(1, -1);

          if (parameter === "catVal") {
            //special case - skip one
            idx++;
          }

          let strParam;
          try {
            strParam = Messenger.reqres.request("param:" + paramArray[i], paramArray[i], idx);
          } catch (e) {
            console.error("Failed to retrieve report parameter " + parameter, e);
            strParam = "";
          }

          if (parameter === "bucket" && strParam <= 1) {
            strParam = strParam * 10;
          }

          retVal[parameter] = strParam;

          // For dates, also include a formatted version so we aren't displaying the date in Unix time.
          // That might work for some Unix sysadmin gurus, but most of our customers will probably prefer local
          // formatting
          if (parameter.indexOf("Date") > 0) {
            retVal[parameter + "Formatted"] = Messenger.reqres.request(
              "get:formatted:date",
              strParam,
            );
          }

          idx++;
        }

        // Also store the time zone input
        try {
          retVal.timeZone = Messenger.reqres.request("param:{timeZone}");
        } catch (e) {
          console.error("Failed to get time zone parameter, guessing using Moment", e);
          retVal.timeZone = Moment.tz.guess();
        }
      }
      return retVal;
    },
  };
  return ReportUtils;
});
